module.exports = __webpack_public_path__ + "img/orion-coloured-2.1bbe4bfd.svg";